(() => {
  const initStickyAddToCart = () => {
    if (!document.body.classList.contains('template-product') || document.querySelector('.laft-sticky-atc')) return;
    const originalButton = document.querySelector('.product-form__submit[name="add"]');
    if (!originalButton) return;
    const wrapper = document.createElement('div');
    wrapper.className = 'laft-sticky-atc';
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'button button--primary';
    button.textContent = originalButton.textContent.trim() || 'Add to cart';
    button.disabled = originalButton.disabled;
    button.setAttribute('aria-label', 'Add selected product to cart');
    button.addEventListener('click', () => originalButton.click());
    wrapper.appendChild(button);
    document.body.appendChild(wrapper);
    const sync = () => { button.disabled = originalButton.disabled; button.textContent = originalButton.textContent.trim() || 'Add to cart'; };
    new MutationObserver(sync).observe(originalButton, { attributes: true, childList: true, subtree: true });
    const observer = new IntersectionObserver(([entry]) => wrapper.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0.05 });
    observer.observe(originalButton);
  };
  document.addEventListener('DOMContentLoaded', initStickyAddToCart);
  document.addEventListener('shopify:section:load', initStickyAddToCart);
})();
